import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
function Contact() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const button = (e) => {
    e.preventDefault();
    if ((email, name, message)) {
      toast.success("Message has been sent successfuuly");
    } else if ((!email, !name, !message)) {
      toast.error("Unable to send messages at this time. Check your input");
    }
  };

  return (
    <div>
      <div className="square">
        <ToastContainer />
        <center>
          {/* <div style={{ position: "relative", bottom: "30px" }}>
            <b>
              <a
                href="https://twitter.com/@KAYODE__"
                className="form-control"
                style={{ width: "50%" }}
              >
                <span>
                  <i
                    className="fab fab-twitter"
                    style={{ color: "Blue", fontSize: "25px" }}
                  >
                    twitter
                  </i>
                </span>
              </a>
            </b>
            <a
              href="https://wa.me/+2349026524611"
              className="form-control"
              style={{ width: "50%" }}
            >
              <span>
                <i
                  className="fab fab-whatsapp"
                  style={{ color: "green", fontSize: "25px" }}
                >
                  whatsapp
                </i>
              </span>
            </a>
          </div> */}
          <div className="square-two">
            <h3 className="get" style={{ fontSize: "18px", padding: "10px" }}>
              Get In Touch!
            </h3>
            <p style={{ fontWeight: "bolder", fontSize: "13px" }}>
              Have any business Idea,Hit me up
            </p>
            <form>
              <input
                type="text"
                placeholder="Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="form-control"
                style={{ width: "70%", fontSize: "13px" }}
              />
              <br />
              <br />
              <input
                type="text"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="form-control"
                style={{ width: "70%", fontSize: "13px" }}
              />
              <br />
              <br />
              <textarea
                type="text"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Write your message"
                className="form-control"
                style={{ width: "70%", fontSize: "13px" }}
              ></textarea>
              <br />
              <br />
              <button
                className="btn btn-primary"
                onClick={button}
                style={{ width: "70%", position: "relative", bottom: "35px" }}
              >
                Submit
              </button>
            </form>
          </div>
        </center>
      </div>
      <p
        style={{
          color: "white",
          position: "relative",
          top: "15px",
          fontSize: "10px",
          textTransform: "capitalize",
          textAlign: "center",
          fontWeight: "bolder",
        }}
      >
        &#169; Copyright-Tee~codes 2023
      </p>
    </div>
  );
}

export default Contact;
